
































import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    showCheck: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    return {};
  },
});
